import { supabase } from '@/integrations/supabase/client';
import { todayBR } from '@/lib/utils';

/**
 * Registra automaticamente a entrada do ponto ao fazer login.
 * Deve ser chamado uma vez após o login ser confirmado.
 */
export async function registrarEntradaAutomatica(userId: string) {
  try {
    // Buscar funcionário vinculado ao user
    const { data: func } = await (supabase as any)
      .from('funcionarios')
      .select('id')
      .eq('user_id', userId)
      .eq('status', 'ativo')
      .maybeSingle();

    if (!func) return;

    const hoje = todayBR();

    // Verificar se está de férias
    const { data: ausencias } = await supabase
      .from('ferias_ausencias')
      .select('id')
      .eq('funcionario_id', func.id)
      .eq('status', 'aprovado')
      .lte('data_inicio', hoje)
      .gte('data_fim', hoje);

    if (ausencias && ausencias.some((a: any) => true)) {
      // Check if any is ferias type
      const { data: ferias } = await supabase
        .from('ferias_ausencias')
        .select('id')
        .eq('funcionario_id', func.id)
        .eq('status', 'aprovado')
        .eq('tipo', 'ferias')
        .lte('data_inicio', hoje)
        .gte('data_fim', hoje);
      
      if (ferias && ferias.length > 0) return; // Em férias, não registrar
    }

    // Verificar se já existe registro hoje
    const { data: existing } = await (supabase as any)
      .from('registros_ponto')
      .select('id')
      .eq('funcionario_id', func.id)
      .eq('data', hoje)
      .maybeSingle();

    if (existing) return; // Já registrado hoje

    // Criar registro com entrada automática
    await (supabase as any).from('registros_ponto').insert({
      funcionario_id: func.id,
      data: hoje,
      entrada: new Date().toISOString(),
      origem_entrada: 'login',
      status: 'normal',
    });
  } catch (e) {
    console.error('Erro ao registrar ponto automático:', e);
  }
}
